export default __webpack_public_path__ + "static/media/bg4.a35d63da.png";